import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonEs from "./locales/es/common.json";
import navbarEs from "./locales/es/navbar.json";
import loginEs from "./locales/es/login.json";
import dashboardEs from "./locales/es/dashboard.json";
import settingsEs from "./locales/es/settings.json";
import validateEs from "./locales/es/validate.json";
import checkoutSuccessEs from "./locales/es/checkoutSuccess.json";
import checkoutEs from "./locales/es/checkout.json";
import cookiesEs from "./locales/es/cookies.json";
import brandingEs from "./locales/es/branding.json";
import salesEs from "./locales/es/sales.json";
import overviewEs from "./locales/es/overview.json";
import legalEs from "./locales/es/legal.json";
import rgpdEs from "./locales/es/rgpd.json";
import dpaEs from "./locales/es/dpa.json";
import notifyEs from "./locales/es/notify.json";
import footerEs from "./locales/es/footer.json";
import cancelEventEs from "./locales/es/cancelEvent.json";
import mcpEs from "./locales/es/mcp.json";
import orgEs from "./locales/es/org.json";
import providerEs from "./locales/es/provider.json";
import doorEs from "./locales/es/door.json";
import embedEs from "./locales/es/embed.json";

import commonEn from "./locales/en/common.json";
import navbarEn from "./locales/en/navbar.json";
import loginEn from "./locales/en/login.json";
import dashboardEn from "./locales/en/dashboard.json";
import settingsEn from "./locales/en/settings.json";
import validateEn from "./locales/en/validate.json";
import checkoutSuccessEn from "./locales/en/checkoutSuccess.json";
import checkoutEn from "./locales/en/checkout.json";
import cookiesEn from "./locales/en/cookies.json";
import brandingEn from "./locales/en/branding.json";
import salesEn from "./locales/en/sales.json";
import overviewEn from "./locales/en/overview.json";
import legalEn from "./locales/en/legal.json";
import rgpdEn from "./locales/en/rgpd.json";
import dpaEn from "./locales/en/dpa.json";
import notifyEn from "./locales/en/notify.json";
import footerEn from "./locales/en/footer.json";
import cancelEventEn from "./locales/en/cancelEvent.json";
import mcpEn from "./locales/en/mcp.json";
import orgEn from "./locales/en/org.json";
import providerEn from "./locales/en/provider.json";
import doorEn from "./locales/en/door.json";
import embedEn from "./locales/en/embed.json";

const NS = [
  "common",
  "navbar",
  "login",
  "dashboard",
  "settings",
  "validate",
  "checkoutSuccess",
  "checkout",
  "cookies",
  "branding",
  "sales",
  "overview",
  "legal",
  "rgpd",
  "dpa",
  "notify",
  "footer",
  "cancelEvent",
  "mcp",
  "org",
  "provider",
  "door",
  "embed",
];

const resources = {
  es: {
    common: commonEs,
    navbar: navbarEs,
    login: loginEs,
    dashboard: dashboardEs,
    settings: settingsEs,
    validate: validateEs,
    checkoutSuccess: checkoutSuccessEs,
    checkout: checkoutEs,
    cookies: cookiesEs,
    branding: brandingEs,
    sales: salesEs,
    overview: overviewEs,
    legal: legalEs,
    rgpd: rgpdEs,
    dpa: dpaEs,
    notify: notifyEs,
    footer: footerEs,
    cancelEvent: cancelEventEs,
    mcp: mcpEs,
    org: orgEs,
    provider: providerEs,
    door: doorEs,
    embed: embedEs,
  },
  en: {
    common: commonEn,
    navbar: navbarEn,
    login: loginEn,
    dashboard: dashboardEn,
    settings: settingsEn,
    validate: validateEn,
    checkoutSuccess: checkoutSuccessEn,
    checkout: checkoutEn,
    cookies: cookiesEn,
    branding: brandingEn,
    sales: salesEn,
    overview: overviewEn,
    legal: legalEn,
    rgpd: rgpdEn,
    dpa: dpaEn,
    notify: notifyEn,
    footer: footerEn,
    cancelEvent: cancelEventEn,
    mcp: mcpEn,
    org: orgEn,
    provider: providerEn,
    door: doorEn,
    embed: embedEn,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "es",
    supportedLngs: ["es", "en"],
    ns: NS,
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "pikra_lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

if (typeof document !== "undefined") {
  const apply = (lng) => {
    try {
      document.documentElement.setAttribute("lang", lng || "es");
    } catch {
      // Ignore DOM failures.
    }
  };
  apply(i18n.language);
  i18n.on("languageChanged", apply);
}

export default i18n;
